export enum DrawingMode {
    BeforeDraw = 0,
    Drawing = 1,
    AfterDraw = 2
}
